/**
 * @generated SignedSource<<a817dc385696f6c2324690d19ec284f0>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderInlineDataFragment } from 'relay-runtime';
export type Country = "CH" | "DE";
export type Gender = "FEMALE" | "MALE" | "OTHER" | "UNKNOWN";
export type Language = "ENGLISH" | "FRENCH" | "GERMAN" | "ITALIAN";
import { FragmentRefs } from "relay-runtime";
export type PatientFragmentInline$data = {
  readonly __typename: string;
  readonly address: {
    readonly city: string;
    readonly houseNumberStreet: string;
    readonly postalCode: string;
  } | null;
  readonly age: {
    readonly days: number;
    readonly months: number;
    readonly weeks: number;
    readonly years: number;
  };
  readonly birthDate: any;
  readonly country: Country;
  readonly displayId: number;
  readonly emailAddress: string | null;
  readonly firstName: string;
  readonly gender: Gender;
  readonly id: string;
  readonly isEligibleForPreventionProgram: boolean;
  readonly lastName: string;
  readonly patientFileLock: {
    readonly " $fragmentSpreads": FragmentRefs<"PatientFileLockFragment" | "PatientFileLockFragmentInline">;
  };
  readonly phoneNumber: string | null;
  readonly primaryLanguage: Language;
  readonly secondaryLanguages: ReadonlyArray<Language>;
  readonly " $fragmentType": "PatientFragmentInline";
};
export type PatientFragmentInline$key = {
  readonly " $data"?: PatientFragmentInline$data;
  readonly " $fragmentSpreads": FragmentRefs<"PatientFragmentInline">;
};

const node: ReaderInlineDataFragment = {
  "kind": "InlineDataFragment",
  "name": "PatientFragmentInline"
};

(node as any).hash = "3d709ed608b3209b08129b8f764076a3";

export default node;
